export const WELL_CONFIGURATION__FETCH_WELLS = 'WELL_CONFIGURATION__FETCH_WELLS';
export const WELL_CONFIGURATION__FETCH_WELLS_SUCCEEDED = 'WELL_CONFIGURATION__FETCH_WELLS_SUCCEEDED';
export const WELL_CONFIGURATION__FETCH_WELLS_FAILED = 'WELL_CONFIGURATION__FETCH_WELLS_FAILED';

export const WELL_CONFIGURATION__SAVE_WELL_CONFIGURATION = 'WELL_CONFIGURATION__SAVE_WELL_CONFIGURATION';
export const WELL_CONFIGURATION__SAVE_WELL_CONFIGURATION_SUCCEEDED = 'WELL_CONFIGURATION__SAVE_WELL_CONFIGURATION_SUCCEEDED';
export const WELL_CONFIGURATION__SAVE_WELL_CONFIGURATION_FAILED = 'WELL_CONFIGURATION__SAVE_WELL_CONFIGURATION_FAILED';
